export default "__VITE_PUBLIC_ASSET__95236a76__"